<template>
  <v-navigation-drawer
        :value="drawer"
        @input="$emit('update:drawer', $event)"
        app
        clipped
        v-if="user"
        color="primary"
        dark
        :permanent="$vuetify.breakpoint.mdAndUp"
        :temporary="$vuetify.breakpoint.smAndDown"
        :style="{ zIndex: $vuetify.breakpoint.smAndDown ? 1000 : 32 }"
      >
        <v-list dense nav>
          <v-list-item to="/" active-class="sidebar-active">
            <v-list-item-action>
              <v-icon>fas fa-chart-line</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Dashboard</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-expansion-panels v-model="activeGroup" accordion flat dark class="sidebar-panels">
          <v-expansion-panel v-for="(menu,i) in filteredMenus" :key="i">
            <v-expansion-panel-header class="sidebar-panel-header">
              {{ menu.title }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list dense nav class="pa-0">
                <v-list-item
                  v-for="(item,index) in menu.items"
                  :key="index"
                  :to="`/${item.link}`"
                  active-class="sidebar-active"
                >
                  <v-list-item-action>
                    <v-icon small>{{ item.icon }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <template v-slot:append>
          <div class="pa-4 border-top-light">
            <v-btn 
              block 
              text 
              class="logout-btn font-weight-black text-none justify-start px-4 rounded-lg white--text opacity-80" 
              @click="$emit('logout')"
              height="48"
            >
              <v-icon left small class="mr-3">fas fa-sign-out-alt</v-icon>
              Cerrar Sesión
            </v-btn>
          </div>
        </template>
      </v-navigation-drawer>
</template>

<script>
import menus from '@/utils/menu'
export default {
  name:'SideMenu',
  props:['drawer','user'],
  data() {
    return {
      activeGroup: null,
      menus: menus,
    }
  },
  computed:{
    filteredMenus(){
      return this.menus.map(menu => {
        const filtered = { ...menu }
        filtered.items = menu.items.filter(item => this.$can('read', item.gate))

        const softnetDisabled = !this.$store.getters.getCompany.softnet_integration_enabled
        if (softnetDisabled) {
          filtered.items = filtered.items.filter(item => item.link !== 'sales/softnet-documents')
        }
        const kameDisabled = !this.$store.getters.getCompany.kame_integration_enabled
        if (kameDisabled) {
          filtered.items = filtered.items.filter(item => item.link !== 'sales/kame-documents')
        }

        const relbaseEnabled = this.$store.getters.getCompany.relbase_integration_enabled
        
        if (!relbaseEnabled) {
          // Si Relbase está desactivado, quitar sus enlaces
          filtered.items = filtered.items.filter(item => 
            item.link !== 'ventas/relbase-documents' &&
            item.link !== 'reports/relbase-sync' &&
            item.link !== 'reports/relbase-product-billing'
          )
          if (menu.title === 'Relbase') {
            filtered.items = []
          }
        } else {
          // Si Relbase está activado, ocultar los enlaces de facturación tradicionales
          // porque son redundantes o incompatibles
          filtered.items = filtered.items.filter(item => 
            item.link !== 'sales/invoices' &&
            item.link !== 'reports/work-order-invoice' &&
            item.link !== 'reports/product-invoice'
          )
        }

        return filtered
      }).filter(menu => menu.items.length > 0)
    }
  },
  methods:{
    goTo(link){
        this.$router.push('/'+link)
      },
  }
}
</script>

<style scoped>
/* Expansion panels on dark sidebar */
.sidebar-panels {
  background: transparent !important;
}
.sidebar-panels >>> .v-expansion-panel {
  background: transparent !important;
  color: #fff;
}
.sidebar-panels >>> .v-expansion-panel::before {
  box-shadow: none !important;
}
.sidebar-panels >>> .v-expansion-panel-header {
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  font-weight: 600;
  min-height: 40px;
  padding: 8px 16px;
}
.sidebar-panels >>> .v-expansion-panel-header:hover {
  color: #fff;
}
.sidebar-panels >>> .v-expansion-panel-header--active {
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
}
.sidebar-panels >>> .v-expansion-panel-header .v-icon {
  color: rgba(255, 255, 255, 0.7) !important;
}
.sidebar-panels >>> .v-expansion-panel-content__wrap {
  padding: 0;
}
/* Active sidebar item: turquoise left border + subtle bg */
.sidebar-active {
  background: rgba(53, 189, 200, 0.12) !important;
  border-left: 4px solid var(--v-accent-base);
  color: var(--v-accent-base) !important;
}
.sidebar-active .v-icon {
  color: var(--v-accent-base) !important;
}

.border-top-light {
  border-top: 1px solid rgba(255,255,255,0.08) !important;
}

.logout-btn {
  transition: all 0.3s ease !important;
}

.logout-btn:hover {
  background: rgba(255, 255, 255, 0.05) !important;
  opacity: 1 !important;
}
</style>
